/** Client-side file downloads for the history export buttons. */

/** Triggers a browser download of the given content. */
export const downloadFile = (filename: string, content: string, mimeType: string): void => {
  const url = URL.createObjectURL(new Blob([content], { type: mimeType }));
  const link = document.createElement('a');

  link.href = url;
  link.download = filename;
  link.click();

  URL.revokeObjectURL(url);
};

export const downloadJson = (filename: string, data: unknown): void =>
  downloadFile(filename, JSON.stringify(data, null, 2), 'application/json');

/** Quotes a CSV cell, escaping any embedded quotes. */
const csvCell = (value: unknown): string => {
  const text = value == null ? '' : String(value);
  return `"${text.replace(/"/g, '""')}"`;
};

export const downloadCsv = (filename: string, headers: string[], rows: unknown[][]): void => {
  const content = [headers, ...rows].map((row) => row.map(csvCell).join(',')).join('\n');
  // ExcelがUTF-8として開けるようBOMを付ける
  downloadFile(filename, `﻿${content}`, 'text/csv;charset=utf-8');
};

/** Name like "planning-poker-history-<room>-2026-07-29.json". */
export const historyFilename = (roomId: string, extension: string): string =>
  `planning-poker-history-${roomId}-${new Date().toISOString().split('T')[0]}.${extension}`;
